import styled from 'styled-components/native';

export const Container = styled.TouchableOpacity.attrs({
  activeOpacity: 0.9,
})``;

export const Loading = styled.ActivityIndicator.attrs({
  size: 'small',
})``;
